<template>
<div id="invoice-list-loading">
  <vs-table :data="invoices">
    <template slot="thead">
      <th-sort :text="$t('client')"         column="cl.ClientName" @sort="handleClickSort"/>
      <th-sort :text="`${$t('year')} - ${$t('week')}`"         column="p.Year,p.Week" @sort="handleClickSort"/>
      <th-sort :text="$t('qb_invoice')"         column="Invoices.QBInvoiceId" @sort="handleClickSort"/>
      <th width="150px" class="text-center">{{ $t("actions") }}</th>
    </template>

    <template slot-scope="{ data }">
      <vs-tr :key="i" v-for="(tr, i) in data">
        <cell-input class="text-left" :value="data[i].ClientName" disabled width='40vw' />

        <cell-input class="text-left" :value="data[i].WeekInvoice != null ? data[i].WeekInvoice:''" disabled width='17vw'/>

        <cell-input
          class="text-left"
          :value="data[i].QBInvoiceId"
          :id="data[i].InvoiceId"
          column="QBInvoiceId"
          @update="updateCell"
          type="number"
          :validateRules="'required|min_value:1'"
          :minField="1"
          :max="10"
          :disabled="!allowEditing"
          width='18vw'
        />
        <cell-action disabled class="text-center" width='25vw'>
          <template>
            <div>
              <action-show-pdf
                class="icon-action"
                :src="data[i].url_file"
                :title="`${data[i].Year} - ${data[i].Week} | ${data[i].InvoiceId} |`"
                :tooltipText="$t('show_pdf')"
                v-if="data[i].url_file != null"
              />
              <template v-if="allowEditing">
                <action-send-invoice disabled :popupTitle="$t('resend_invoice')" class="icon-action" :data="data[i]" :tooltipText="$t('resend')" />
                <action-regenerate-invoice 
                :popupTitle="$t('regenerate_invoice')" 
                class="icon-action" 
                :data="data[i]" 
                :tooltipText="$t('regenerate')"
                />
                <expense-and-payroll-related module="contralor" :popupTitle="`${$t('expenses')} ${$t('and')} ${$t('payroll')}`" class="icon-action" :data="data[i]" :tooltipText="`${$t('expenses')} ${$t('and')} ${$t('payroll')}`"/>               
              </template>
              
            </div>
          </template>
        </cell-action>
      </vs-tr>
      <vs-tr>
        <vs-td colspan="100%">
          <div
            v-if="data.length"
            v-observe-visibility="infiniteHandler"
          ></div>
        </vs-td>
      </vs-tr>
    </template>
  </vs-table>
  </div>
</template>

<script>
import CellInput from '@/components/cell-edit/CellInput.vue'
import CellAction from '@/components/cell-edit/CellAction.vue'
import ActionShowPdf from '@/views/components/actions/ActionShowPdf.vue'
import ActionRegenerateInvoice from '@/views/apps/invoices/components/ActionRegenerateInvoice.vue'
import ActionSendInvoice from '@/views/apps/invoices/components/ActionSendInvoice.vue'
import ThSort from '@/views/components/ThSort.vue'
import ExpenseAndPayrollRelated from '@/views/apps/accounting/components/ExpenseAndPayrollRelated'


import invoice from '@/http/requests/invoice'

export default {
  components: {
    CellInput,
    CellAction,
    ActionRegenerateInvoice,
    ActionSendInvoice,
    ActionShowPdf,
    ThSort,
    ExpenseAndPayrollRelated
  },
  props: {
    reSearch: {
      type: Number,
      default: 0
    },
    searchValue: {
      type: String,
      default: ''
    },
    ClientId: {
      type: Array,
      default: []
    },
    PeriodId: {
      type: Array,
      default: []
    },
    sort: {
      type: Array,
      default: ['DESC']
    },
    sortBy: {
      type: Array,
      default: ['p.Year']
    }
  },
  data() {
    return {
      allowEditing: false,
      lastPage:1,
      params: {
        types: [2],
        page: 1,
        search:this.searchValue,
        ClientId:this.ClientId,
        PeriodId:this.PeriodId,
        sort:this.sort,
        sortBy:this.sortBy
      }
    }
  },
watch:{
  reSearch(){
    this.params.ClientId=this.ClientId
    this.params.PeriodId=this.PeriodId
    this.params.sort=this.sort
    this.params.sortBy=this.sortBy
    this.search()
  }
},
mounted(){
 this.allowEditing = this.hasPermission(['IU CONTRALOR EDIT'])
 this.init()
},
  computed: {
    invoices() {
      return this.$store.state.invoice.invoiceList
    },
  },
  methods: {
    init(){
      this.search()
    },
    updateCell(data) {
      this.openLoading();
      this.$store.dispatch('invoice/updateQBInvoice', data)
      .then((res) => {
        this.$vs.notify({
          color: 'success',
          title: 'Updated',
          text: 'Success',
        })
        this.closeLoading();
      }).catch(err => {
        this.closeLoading();
      })
    },
    search() {      
      this.params.page = 1
      this.params.search = this.searchValue

      for (var propName in this.params) {
        if (this.params[propName] === null || this.params[propName] === undefined || this.params[propName].length === 0) {
          delete this.params[propName];
        }
      }
      //revisar despues
      this.getInvoiceList()
        .then(res =>{this.closeLoading()})
        .catch(err =>{this.closeLoading()})
    },
    handleClickSort(e){
      this.params.sort=e.sort
      this.params.sortBy=e.sortBy
      this.search()
    },
    getInvoiceList: function () {
      this.openLoading()
      return this.$store.dispatch('invoice/fetchInvoiceList',this.params).then(res => {
        this.lastPage = res.data.last_page
      })
    },
    infiniteHandler(isVisible) {
      if (!isVisible) { return }
      if (this.params.page >= this.lastPage) { return }
      this.params.page++
      this.getInvoiceList()
        .then(res => { this.closeLoading() })
        .catch(err => { this.closeLoading() })
    },
    openLoading() {
      this.$vs.loading({
       container: '#invoice-list-loading',
       scale: 0.6
      })
    },
    closeLoading:function() {
      this.$vs.loading.close('#invoice-list-loading > .con-vs-loading')
    },
  },
}
</script>

<style>
.vs-con-table .vs-con-tbody {
  /* height: 80vh;
  width: calc(100vw - 160px); */
  overflow: auto;
}
.fixedHead table {
  /*width: 2500px; */
  table-layout: fixed;
}
.fixedHead table th {
  min-width: 100px;
  cursor: pointer;
}

.fixedHead table thead th:not([scope='row']) {
  position: -webkit-sticky;
  position: sticky;
  top: 0;
  z-index: 2000;
  background-color: #ffffff;
}

.vx-card__body {
  padding: 10px 0px !important;
}

.vs-table--not-data {
  display: none !important;
}

.sm-size {
  font-size: 12px;
}

.comment-truncate {
  overflow-wrap: break-word;
}
.vx-card__title h4 {
  margin-bottom: 2vh;
}
.icon-action {
  display: inline-block;
}
</style>